export const _MS_PER_DAY = 1000 * 60 * 60 * 24;

export const formatDate = (date) => {
  const [year, month, day] = date.slice(0, 10).split('-');
  const result = [day, month, year].join('/');
  return result;
};

export const getDaysDifferenceFromToday = (date) => {
  const today = new Date();
  const utc2 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const utc1 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

export function fullDateToFormattedDate(fullTimestamp) {
  if (fullTimestamp == null) {
    return new Date();
  }
  return fullTimestamp.split('T')[0];
}

// ===== Espace Notifications =====
const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

// Nombre de jours calendaires entre la date et aujourd'hui (0 = aujourd'hui)
export const getNotificationDayDiff = (iso) =>
  Math.round((startOfDay(new Date()) - startOfDay(new Date(iso))) / _MS_PER_DAY);

const hhmm = (d) => d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

// « Aujourd’hui à 08:00 », « Hier à 16:30 », « Mer. 28 oct. à 08:00 »
export const formatNotificationDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const diff = getNotificationDayDiff(iso);
  if (diff === 0) return `Aujourd’hui à ${hhmm(d)}`;
  if (diff === 1) return `Hier à ${hhmm(d)}`;
  const s = d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
  return `${s.charAt(0).toUpperCase() + s.slice(1)} à ${hhmm(d)}`;
};

// Durée écoulée depuis la date : « 10 min », « 3 h », « 2 jours »
export const formatDurationSince = (iso) => {
  const min = Math.max(1, Math.round((new Date() - new Date(iso)) / 60000));
  if (min < 60) return `${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} h`;
  const days = Math.round(h / 24);
  return `${days} ${days > 1 ? 'jours' : 'jour'}`;
};
